var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgMishandlingSensitiveInformation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "29px",
    height: "29px",
    viewBox: "0 0 29 29",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 12") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SELECT-REPORT-TYPE-v1",
    transform: "translate(-505.000000, -687.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-12",
    transform: "translate(505.000000, 687.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-15",
    fill: "#B3D7F4",
    cx: 14.5,
    cy: 14.5,
    r: 14.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "folder-(1)",
    transform: "translate(6.000000, 6.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.2565957,15.9992727 L1.50178723,15.9992727 C1.4623617,15.9992727 1.42980851,15.9709091 1.42438298,15.9327273 L0.00144680851,6.49090909 C-0.00578723404,6.44254545 0.031106383,6.4 0.079212766,6.4 L16.6791702,6.4 C16.7272766,6.4 16.7641702,6.44254545 16.7569362,6.49090909 L15.3343617,15.9327273 C15.3271277,15.9709091 15.2945745,15.9992727 15.2565957,15.9992727 Z",
    id: "Fill-1",
    fill: "#F8B563"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6251702,6.4 L15.6251702,1.968 C15.6251702,1.84618182 15.5264255,1.74509091 15.4034468,1.74509091 L6.49219149,1.74509091 C6.41297872,1.74509091 6.341,1.704 6.30157447,1.63709091 L5.56261702,0.398545455 C5.52319149,0.331636364 5.44940426,0.290545455 5.372,0.290545455 L1.38025532,0.290545455 C1.2576383,0.290545455 1.15708511,0.391636364 1.15708511,0.513454545 L1.15708511,6.4 L15.6251702,6.4 Z",
    id: "Fill-3",
    fill: "#B5885B"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-4",
    fill: "#FFFFFF",
    points: "2.02625532 6.4 14.7578085 6.4 14.7578085 5.23672727 2.02625532 5.23672727"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-5",
    fill: "#E7ECED",
    points: "2.31417021 5.23636364 14.4680851 5.23636364 14.4680851 4.36290909 2.31417021 4.36290909"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-6",
    fill: "#C7CAC7",
    points: "2.60389362 4.36290909 14.1783617 4.36290909 14.1783617 3.49090909 2.60389362 3.49090909"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMishandlingSensitiveInformation);
export default __webpack_public_path__ + "static/media/mishandling-sensitive-information.bbdbe65ce21436a7afb53ecd91bf1af5.svg";
export { ForwardRef as ReactComponent };